export const AUTH_USER = 'AUTH_USER';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_STOP_LOADING = 'AUTH_STOP_LOADING';
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_SUCCESS_MESSAGE = 'AUTH_SUCCESS_MESSAGE';
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
